import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { averageTicketMessages } from 'pages/admin/demand/averageTicket/variables/averageTicketMessages';
import { useHistory } from 'react-router-dom';
import api from 'services/api/api';

type BodyAverageTicket =
	| {
			recalcular: boolean;
			ticket_medio_editado: number;
	  }
	| {
			recalcular: boolean;
			intervaloTempo?: number;
			historico_completo: boolean;
	  };
export const editAverageTicket = async (
	body: BodyAverageTicket,
	id: number
) => {
	const url = `/ticketMedio?id=${id}`;
	const response = await api.patch(url, body);
	return response.data;
};

export const useEditAverageTicket = (id: number, edit = true) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();
	return useMutation({
		mutationFn: (body: BodyAverageTicket) => editAverageTicket(body, id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['ticketMedio-list'] });
			queryClient.invalidateQueries({
				queryKey: ['averageTicketWithId', id],
			});
			edit && history.goBack();
			const msg = averageTicketMessages.MSG_AVERAGE_TICKET_UPDATED;
			toast({
				title: msg.title,
				description: msg.text,
				position: 'bottom-left',
				status: msg.status,
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			const msg = averageTicketMessages.MSG_ERROR_AVERAGE_TICKET_UPDATED;
			toast({
				title: msg.title,
				description:
					error?.response?.data?.message?.[0]?.constraints
						?.isNotEmpty || msg.text,
				position: 'bottom-left',
				status: msg.status,
				duration: 8000,
				isClosable: true,
			});
		},
	});
};
